var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"download":"ufc-staredown-supercut.gif"},on:{"click":_vm.onClick}},[_c('BaseButtonCircle',[_c('img',{attrs:{"src":require("@/assets/img/download.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }